import { getCurrencyFormat, getNumberFormat } from '../../common/utils/functions/currency'
import { formatearPeriodoVisual } from '../../common/utils/functions/periodo'
export const declaracionesAdapter = (rawData) => {
  const data = rawData?.data?.data
  if (data?.length > 0) {
    const rows = data?.map((item) => {
      const {
        ID,
        FECHA_CARGA,
        PERIODO,
        TOTAL_EMPLEADOS,
        TOTAL_MASA_SALARIAL,
        SALARIO_PROMEDIO,
        DEVENGADO_CUOTA,
        FFEP,
        TOTAL_FFEP,
        TOTAL_A_PAGAR,
        ESTADO,
        ESTADO_CABECERA,
      } = item
      return {
        idNomina: ID,
        fecha_de_carga: FECHA_CARGA,
        periodo: formatearPeriodoVisual(PERIODO),
        empleados: getNumberFormat({ value: TOTAL_EMPLEADOS }),
        total_masa_salarial: getCurrencyFormat({ value: TOTAL_MASA_SALARIAL }),
        salario_promedio: getCurrencyFormat({ value: SALARIO_PROMEDIO }),
        devengado_cuota: getCurrencyFormat({ value: DEVENGADO_CUOTA }),
        fondo_ffep: getCurrencyFormat({ value: FFEP }),
        total_ffep: getCurrencyFormat({ value: TOTAL_FFEP }),
        total_a_pagar: getCurrencyFormat({ value: TOTAL_A_PAGAR }),
        estado: ESTADO?.trim().toLowerCase().replace(/\s+/g, '_'),
        acciones: 'accion',
        estado_cabecera: ESTADO_CABECERA,
      }
    })

    return { rows: rows }
  }

  return { rows: [] }
}
